// src/domain/buy/repository.ts

import { Observable } from 'rxjs';
import { Filter } from '../pagination/models';

export abstract class ContableAcountsRepository {
    abstract getContableAcounts(page: number, limit: number, filters: Filter[]): Observable<any>;
}
